// @flow

import { apiHttpUrl } from "./api-url";
import ExtendableError from "es6-error";
import { retryUntilTruthy } from "./promise";

class HttpErrorWithResponse extends ExtendableError {
  constructor(response: Response) {
    super(response.statusText);
    this.response = response;
  }
}

export default function fetchJSON(url: string, options: RequestOptions): Promise<any> {
  var defaults: RequestOptions = {
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    }
  };
  return fetch(apiHttpUrl(url), Object.assign(defaults, options))
    .then(parseJSON);
}

export function checkStatus(response: Response): Response {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    throw new HttpErrorWithResponse(response);
  }
}

function parseJSON(response) {
  var jsonPromise = response.json();

  if (response.status >= 200 && response.status < 300) {
    return jsonPromise;
  } else {
    return jsonPromise.then(errJson => { throw errJson; });
  }
}

export function postJSON(url: string, data: {}): Promise<any> {
  return fetchJSON(url, {
    method: "POST",
    body: JSON.stringify(data)
  });
}

export function fetchUntilChanged(url: string, lastModified: string): Promise<any> {
  return retryUntilTruthy(() =>
    fetchLastModified(url)
      .then(lm => lm !== lastModified),
  1000);
}

export function fetchLastModified(url: string): Promise<string> {
  return fetch(url)
    .then(response => response.headers.get("Last-Modified"));
}
